import { useMutation } from '@tanstack/react-query';

import type { UpdateEmployeeEmploymentContractArgs } from '../../../Domain/Employees/Services/EmployeeService';
import { employeeService } from '../../../Domain/Employees/Services/EmployeeService';

const mutationFn = (data: UpdateEmployeeEmploymentContractArgs) => {
  return employeeService.updateEmployeeEmploymentContract(data);
};

export const useEmployeeUpdateEmploymentContractMutation = () => {
  return useMutation<unknown, unknown, UpdateEmployeeEmploymentContractArgs>(mutationFn);
};
